var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("GenericProps", {
        attrs: { settings: _vm.settings, parameters: _vm.genericParameters },
        on: {
          "update:settings": [
            function($event) {
              _vm.settings = $event
            },
            _vm.updateNodeParent
          ]
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cf-node-properties__field col-md-12 display-flex" },
        [
          _c("label", { staticClass: "control-label" }, [
            _vm._v(
              "\n      " + _vm._s(_vm.goToNodeParameter.displayName) + " "
            ),
            !_vm.goToNodeParameter.isOptional
              ? _c("span", [_vm._v("*")])
              : _vm._e(),
            _vm._v(" "),
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip.top",
                  value: _vm.goToNodeParameter.description,
                  expression: "goToNodeParameter.description",
                  modifiers: { top: true }
                }
              ],
              staticClass: "fa fa-question-circle m-l-5",
              attrs: { "aria-hidden": "true" }
            })
          ]),
          _vm._v(" "),
          _vm.selectedNode
            ? _c("div", { staticClass: "btn-group display-flex flex--grow" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-pre-value m-r-10 flex--grow",
                    attrs: { title: _vm.$t("EDIT_SELECTED_NODE") },
                    on: { click: _vm.viewGoToNode }
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.selectedNode) + "\n        "
                    ),
                    _c("i", {
                      staticClass: "fa fa-reply m-l-5 p-0",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.onSelect }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-crosshairs p-0",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ])
            : _c("div", { staticClass: "btn-group" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary fill-width",
                    on: { click: _vm.onSelect }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("SELECT_NODE")) +
                        "\n        "
                    ),
                    _c("i", {
                      staticClass: "fa fa-crosshairs m-l-10",
                      attrs: { "aria-hidden": "true" }
                    })
                  ]
                )
              ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }